import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import PageTitleImpl from './page-title.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component that shows current page title with icon.
 *
 * @class PageTitle
 * @memberof Mojito.Presentation.Components
 */

/**
 * PageTitle component prop types.
 *
 * @property {string} text - Text to be shown in the page title.
 * @property {Function} [onClick] - Callback function that will run when the page title icon is clicked.
 *
 * @memberof Mojito.Presentation.Components.PageTitle
 */
const propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
};

export default UIView('PageTitle', PageTitleImpl, propTypes);
